import { QuestionBase } from './question-base.model';
import moment from 'proxies/dayjs';

export class DateRangePickerQuestion extends QuestionBase<number> {
   controlType = 'daterangepicker';
   singleDatePicker: boolean = false;
   locale: any;
   autoApply: boolean;
   showClearButton: boolean;
   disabled: boolean;
   visible: boolean;
   timePicker: boolean;
   timePickerSeconds: boolean;
   timePickerIncrement: string;
   timePicker24Hour: boolean;
   minDateNumber: number;
   minDateUnit: any;
   maxDateNumber: number;
   maxDateUnit: any;
   outPutFormat: any;
   showDropdowns: boolean;
   selected: boolean;
   showCustomRangeLabel: boolean;
   startKey: any;
   endKey: any;
   enableInput: boolean;
   minDate: any;
   maxDate: any;
   startOfDay: any=false;
   forceEndOfDay: boolean=false;
   type: any;
   endOfDay: boolean = false;
   maxSpan: number;
   randomSelection: any;
   defaultDaysAfter: any;
   priorDate:any
   subsequentDate:any
   calculated_field_type: string;
   calculation_formula: any;
   select_defination: any;
   endOfDayTime: boolean = false;

   constructor(options: {} = {}) {
      super(options);
      this.singleDatePicker = (options['singleDatePicker'] == undefined) ? false : options['singleDatePicker'];
      this.locale = (options['locale'] == undefined) ? { format: 'DD/MM/YYYY', firstDay: 1 } : options['locale'];
      this.autoApply = (options['autoApply'] == undefined) ? true : options['autoApply'];
      this.showClearButton = (options['showClearButton'] == undefined) ? true : options['showClearButton'];
      this.disabled = (options['disabled'] == undefined) ? false : options['disabled'];
      this.visible = (options['visible'] == undefined) ? true : options['visible'];
      this.timePicker = (options['timePicker'] == undefined) ? false : options['timePicker'];
      this.timePickerSeconds = (options['timePickerSeconds'] == undefined) ? true : options['timePickerSeconds'];
      this.timePickerIncrement = (options['timePickerIncrement'] == undefined) ? "1" : options['timePickerIncrement'];
      this.timePicker24Hour = (options['timePicker24Hour'] == undefined) ? true : options['timePicker24Hour'];
      this.minDateNumber = options['minDateNumber'];
      this.minDateUnit = options['minDateUnit'];
      this.maxDateNumber = options['maxDateNumber'];
      this.maxDateUnit = options['maxDateUnit'];
      this.maxSpan = options['maxSpan'];
      this.outPutFormat = options['outPutFormat'];
      this.showDropdowns = (options['showDropdowns'] === undefined) ? true : options['showDropdowns'];
      this.selected = (options['selected'] == undefined) ? false : options['selected'];
      this.showCustomRangeLabel = (options['showCustomRangeLabel'] == undefined) ? false : options['showCustomRangeLabel'];
      this.startKey = options['startKey'];
      this.endKey = options['endKey'];
      this.enableInput = (options['enableInput'] == undefined) ? false : options['enableInput'];
      this.forceEndOfDay = (options['forceEndOfDay'] == undefined) ? false : options['forceEndOfDay'];
      this.minDate = options['minDate'];
      this.maxDate = options['maxDate'];
      this.conditions = options['conditions'] || '';
      this.startOfDay = options['startOfDay'];
      this.type = options['type'] || '';
      this.endOfDay = options['endOfDay'];
      this.randomSelection = (options['randomSelection'] == undefined) ? false : options['randomSelection'];
      this.defaultDaysAfter = (options['defaultDaysAfter'] == undefined) ? false : options['defaultDaysAfter'];
      this.priorDate = (options['priorDate'] == undefined) ? false : options['priorDate'];
      this.subsequentDate = (options['subsequentDate'] == undefined) ? false : options['subsequentDate'];
      this.calculated_field_type = options['calculated_field_type'] || '';
      this.calculation_formula = options['calculation_formula'];
      this.select_defination = options['select_defination'] || '';
      this.endOfDayTime = (options['endOfDayTime'] == undefined) ? false : options['endOfDayTime'];
   }
}